import React, { createContext, useContext, useState, useEffect } from 'react';

const ContractorAuthContext = createContext(null);

export function ContractorAuthProvider({ children }) {
  const [contractor, setContractor] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('contractor_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      const stored = localStorage.getItem('contractor_data');
      if (stored) {
        try { setContractor(JSON.parse(stored)); } catch { setContractor(null); }
      }
    }
    setLoading(false);
  }, [token]);

  const login = (tokenVal, contractorData) => {
    localStorage.setItem('contractor_token', tokenVal);
    localStorage.setItem('contractor_data', JSON.stringify(contractorData));
    setToken(tokenVal);
    setContractor(contractorData);
  };

  const logout = () => {
    localStorage.removeItem('contractor_token');
    localStorage.removeItem('contractor_data');
    setToken(null);
    setContractor(null);
  };

  return (
    <ContractorAuthContext.Provider value={{ contractor, token, loading, login, logout }}>
      {children}
    </ContractorAuthContext.Provider>
  );
}

export const useContractorAuth = () => useContext(ContractorAuthContext);
